export class InvalidCognitoClinicIdsError extends Error {
  public clinicIds: string

  public constructor(clinicIds: string) {
    super('Invalid cognito clinic ids')
    this.clinicIds = clinicIds
  }
}
